import { __awaiter, __generator, __makeTemplateObject } from "tslib";
import { css, jsx } from '@emotion/react';
import { Button, Text, View, useTheme, Texts } from '@ion-ui/core';

var CallImg = function CallImg() {
  return jsx("svg", {
    width: '224',
    height: '143',
    viewBox: '0 0 224 143',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, jsx("path", {
    d: 'M220.26 112.529C220.26 112.529 243.534 22.0032 173.96 31.3872C169.581 32.0077 165.145 32.1241 160.74 31.7339C126.41 28.4375 131.413 5.39165 81.9162 6.56685C28.6302 7.83608 -37.2253 111.005 25.7032 128.745C93.2008 147.777 206.383 152.569 220.26 112.529Z',
    fill: '#C8F9E1'
  }), jsx("path", {
    d: 'M50.1211 41.0859V111.242C50.1211 116.404 54.6618 120.589 60.263 120.589H178.225C183.827 120.589 188.367 116.404 188.367 111.242V41.0859H50.1211Z',
    fill: '#17CF77'
  }), jsx("path", {
    d: 'M153.947 20.0038L123.961 1.82797C121.044 0.0599477 117.579 0.0599477 114.662 1.82797L84.6763 19.9958L50.041 40.9918L84.6763 61.9235L119.312 82.8598L153.947 61.9006L188.582 40.9918L153.947 20.0038Z',
    fill: '#109354'
  }), jsx("mask", {
    id: 'mask0_9154_38653',
    style: {
      maskType: 'alpha'
    },
    maskUnits: 'userSpaceOnUse',
    x: '50',
    y: '0',
    width: '139',
    height: '83'
  }, jsx("path", {
    d: 'M180.238 1.82801H123.959C121.042 0.0599908 117.577 0.0599908 114.66 1.82801L58.7383 0L50.0391 40.9918L84.6743 61.9235L119.31 82.8599L153.945 61.9006L188.58 40.9918L180.238 1.82801Z',
    fill: '#109354'
  })), jsx("g", {
    mask: 'url(#mask0_9154_38653)'
  }, jsx("path", {
    d: 'M162.313 6.9043H65.5377C63.8312 6.9043 62.418 8.38663 62.418 10.0973V88.7714H176.194V21.0301L162.313 6.9043Z',
    fill: '#EDFDF5'
  }), jsx("path", {
    d: 'M176.141 21.0314L163.443 21.1461C163.285 21.1476 163.129 21.1157 162.984 21.0527C162.839 20.9896 162.71 20.8968 162.603 20.7801C162.364 20.5415 162.34 20.2191 162.34 19.8818V7.00195L176.141 21.0314Z',
    fill: '#5ADEA6'
  })), jsx("path", {
    d: 'M50.4624 119.197C48.3362 115.827 41.9338 107.068 33.4075 108.226C24.1113 109.487 43.669 115.673 49.6544 119.224C48.3243 119.241 47.1802 119.135 46.3411 118.831C42.3414 117.387 35.4884 120.155 33.2978 121.123H71.3884C70.9535 119.645 69.9799 118.388 68.6639 117.606C68.0394 117.219 66.7832 117.166 65.16 117.291C67.4244 114.595 68.9976 105.977 62.6929 108.197C58.0853 109.817 58.0972 115.079 58.5501 118.194C57.5704 118.348 56.5765 118.504 55.5944 118.646C53.6875 108.888 46.9919 80.2814 33.3956 79.5184C19.6133 78.7457 45.0754 109.186 53.5635 118.921C52.4766 119.053 51.4302 119.152 50.4624 119.197Z',
    fill: '#14B869'
  }), jsx("path", {
    d: 'M84.8165 111.782L84.7656 131.121L96.0153 131.115L96.0209 128.87L86.9929 128.842L87.0438 111.084C86.3598 111.347 85.6362 111.582 84.8165 111.782ZM70.1581 109.812L70.1016 131.121L81.3512 131.115L81.3568 128.87L72.3289 128.842L72.3798 110.78C71.6166 110.471 70.8817 110.133 70.1581 109.812Z',
    fill: '#021215'
  }), jsx("path", {
    d: 'M57.2803 86.7906C62.9346 85.5535 63.1793 83.5891 64.1691 79.2996C66.0576 71.127 73.5267 67.5533 80.4496 70.3768C86.9288 73.017 84.8696 82.4953 90.7401 81.0177C97.1227 79.4084 102.356 79.2996 104.25 85.1355C105.815 89.9462 103.977 94.8944 109.819 95.0834C117.414 95.3239 117.516 110.14 104.159 107.929C89.7105 105.535 91.8494 112.356 79.1526 112.356C72.0021 112.356 67.3888 106.457 61.3248 108.422C51.404 111.64 46.8134 103.359 46.4493 99.3214C46.0227 94.6538 47.9454 88.8351 57.2803 86.7906Z',
    fill: '#FCFCFC'
  }), jsx("path", {
    d: 'M81.7426 105.202C85.5388 105.202 87.1585 101.102 87.4824 98.8617L85.3058 98.5234C85.3058 98.5351 85.1069 99.8067 84.4705 100.991C83.726 102.385 82.7599 103.015 81.5096 102.933C80.7254 102.881 80.14 102.606 79.7252 102.099C78.7591 100.915 78.9523 98.8384 78.9523 98.8209L76.7644 98.5701C76.753 98.6926 76.4575 101.609 78.0373 103.546C78.8443 104.537 79.9639 105.091 81.3619 105.185C81.4926 105.202 81.6176 105.202 81.7426 105.202Z',
    fill: '#021215'
  }), jsx("path", {
    d: 'M175.845 101.006V111.661L171.587 101.006H167.128V112.728H169.772V102.073L174.03 112.728H178.488V101.006H175.845ZM159.38 111.005C157.52 111.005 156.198 109.298 156.198 106.875C156.198 104.451 157.521 102.744 159.38 102.744C161.24 102.744 162.562 104.451 162.562 106.875C162.562 109.298 161.241 111.005 159.38 111.005ZM159.38 112.896C162.639 112.896 165.207 110.167 165.207 106.875C165.207 103.566 162.639 100.854 159.38 100.854C156.121 100.854 153.554 103.566 153.554 106.875C153.554 110.167 156.121 112.896 159.38 112.896ZM148.988 112.728H151.632V101.006H148.988V112.728Z',
    fill: '#021215'
  }), jsx("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M102.031 40.0973C102.031 30.7335 109.596 23.1426 118.927 23.1426C128.258 23.1426 135.822 30.7335 135.822 40.0973C135.822 49.4611 128.258 57.052 118.927 57.052C109.596 57.052 102.031 49.4611 102.031 40.0973ZM118.927 26.1127C111.23 26.1127 104.991 32.3738 104.991 40.0973C104.991 47.8208 111.23 54.0819 118.927 54.0819C126.623 54.0819 132.863 47.8208 132.863 40.0973C132.863 32.3738 126.623 26.1127 118.927 26.1127ZM127.68 34.4062C128.258 34.9862 128.258 35.9265 127.68 36.5064L115.843 48.3853L110.172 42.6943C109.594 42.1143 109.594 41.174 110.172 40.594C110.75 40.0141 111.687 40.0141 112.265 40.594L115.843 44.1848L125.588 34.4062C126.165 33.8262 127.103 33.8262 127.68 34.4062Z',
    fill: '#17CF77'
  }));
};

export var LeadView = function LeadView(_a) {
  var thanksName = _a.thanksName,
      redirectOnbording = _a.redirectOnbording,
      user = _a.user,
      setScreen = _a.setScreen,
      isMultisimulator = _a.isMultisimulator,
      cleanValues = _a.cleanValues,
      onClose = _a.onClose,
      heroLayout = _a.heroLayout;
  var theme = useTheme();
  var thanksStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color:", ";\n    margin-top:1rem;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: -0.005rem;\n    text-transform:capitalize;\n  "], ["\n    color:", ";\n    margin-top:1rem;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: -0.005rem;\n    text-transform:capitalize;\n  "])), theme.colors.scales.gray[12]);
  var contactStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: Grotta;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 1rem;\n    line-height: 1.25rem;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: ", ";\n    width: 18.938rem;\n  "], ["\n    font-family: Grotta;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 1rem;\n    line-height: 1.25rem;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: ", ";\n    width: 18.938rem;\n  "])), theme.colors.scales.gray[11]);
  return jsx(View, {
    css: mainContent
  }, jsx(View, {
    css: imageContainerStyle
  }, jsx(CallImg, null), jsx(Text, {
    variant: 'h5',
    css: thanksStyle
  }, "\xA1Gracias ".concat(thanksName, "!")), jsx(Text, {
    css: contactStyle
  }, "Nos pondremos en contacto contigo lo m\xE1s pronto posible para poder ayudarte. \xA1Espera nuestra llamada!")), jsx(View, {
    css: buttonsContainer
  }, jsx(Button, {
    css: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["margin-bottom:1rem"], ["margin-bottom:1rem"]))),
    variant: 'outline',
    size: 'md',
    onClick: function onClick() {
      return __awaiter(void 0, void 0, void 0, function () {
        var link;
        return __generator(this, function (_a) {
          link = document.createElement('a');
          link.setAttribute('id', 'callActionClick');
          link.href = 'tel:800 777 92 92';
          link.dispatchEvent(new MouseEvent('click'));
          return [2
          /*return*/
          ];
        });
      });
    }
  }, !heroLayout ? jsx(Text, {
    variant: 'button'
  }, "LL\xC1MANOS AHORA") : jsx(Texts, {
    size: 'medium',
    weight: 'bold',
    variant: 'button'
  }, "LL\xC1MANOS AHORA")), jsx(Button, {
    variant: 'default',
    size: 'md',
    onClick: function onClick() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (redirectOnbording) {
            redirectOnbording(user);
          }

          if (cleanValues) {
            cleanValues();

            if (isMultisimulator) {
              onClose();
              setScreen(0);
            } else {
              setScreen(1);
            }
          }

          return [2
          /*return*/
          ];
        });
      });
    }
  }, jsx(Text, {
    variant: 'button'
  }, "FINALIZAR"))));
};
var imageContainerStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  flex-direction:column;\n"], ["\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  flex-direction:column;\n"])));
var buttonsContainer = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display:flex;\n  justify-content : flex-end;\n  flex-direction : column;\n  min-height:8.125rem;\n"], ["\n  display:flex;\n  justify-content : flex-end;\n  flex-direction : column;\n  min-height:8.125rem;\n"])));
var mainContent = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width:100%;\n  height:31.25rem;\n"], ["\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width:100%;\n  height:31.25rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;